// 多选查询数据转换
// 传入处理好的params，以及需要多选查询的字段、多选查询值

exports.install = (Vue) => {
  Vue.prototype.MultipleQuery = function(params, key, value = []) {
    value.length != 0 ? params.result.push({ conditionalType:"6", fieldName:key, fieldValue:value.join() }) : ""
    return params
  }
}
